<template>
  <TypePdf
    v-if="file.file_extension === 'pdf'"
    :file="file"
  />
  <TypeImage
    v-else-if="file.type === 'IMAGE'"
    :file="file"
  />
  <TypeUnhandled
    v-else
    :file="file"
  />
</template>

<script>
import fileMixin from '../../mixins/fileMixin'

import TypeImage from '../filetypes/TypeImage'
import TypePdf from '../filetypes/TypePdf'
import TypeUnhandled from '../filetypes/TypeUnhandled'

export default {
  components: {
    TypeImage, TypePdf, TypeUnhandled
  },
  mixins: [fileMixin],
  props: {
    file: {
      type: Object,
      required: true
    }
  }
}
</script>
